import * as React from 'react';

import { CalendarActions, ICalendarState } from '@adage/ace-calendar';
import { IArenaEvent } from '../classes/event';
import { connect } from 'react-redux';


import { IOption } from '../../classes/index';
import AccessibilityItem from '../components/accessibility-item';
import { JumpToFirstEventMonth } from '../calendar-helpers'

interface ClearingProps
{
    shouldClear: boolean;
    isMobile: boolean;
}

interface CategorySelectionState {
    isShowsSelected: boolean;
    isOtherOfferingsSelected: boolean;
    isClassesSelected: boolean;
}

export class AccessibilitySelection extends React.Component<ClearingProps, CategorySelectionState> {
    constructor(props) {
        super(props);

        this.state = {
            isShowsSelected: false,
            isClassesSelected: false,
            isOtherOfferingsSelected:false
        };
    };

    componentWillReceiveProps(props: ClearingProps)
    {
        if (props.shouldClear != this.props.shouldClear)
        {
            this.setState({ isShowsSelected: false, isClassesSelected: false, isOtherOfferingsSelected: false });
        }
    }

    private filterBind = this.filter.bind(this)
    private radioButtonChangeBind = this.onRadioButtonChange.bind(this)

    onRadioButtonChange(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.id == "radio-shows") {
            this.setState({ isShowsSelected: !this.state.isShowsSelected, isClassesSelected: false, isOtherOfferingsSelected: false});
        }
        else if (event.target.id == "radio-classes") {
            this.setState({ isClassesSelected: !this.state.isClassesSelected, isShowsSelected: false, isOtherOfferingsSelected: false });
        }
        else {
            this.setState({ isOtherOfferingsSelected: !this.state.isOtherOfferingsSelected, isShowsSelected: false, isClassesSelected: false});
        }

        CalendarActions.updateEventFilter({
            key: "category",
            filter: this.filterBind
        })

        JumpToFirstEventMonth.bind(this)(this.props.isMobile);
    }

    private filter(event: IArenaEvent) {
        var isMatch = false;

        //nothing is selected
        if (this.state.isShowsSelected == false && this.state.isClassesSelected == false && this.state.isOtherOfferingsSelected == false) {
            isMatch = true;
        }

        else {
            if (this.state.isShowsSelected && event.shows) {
                isMatch = true;
            }
            else if (this.state.isOtherOfferingsSelected && event.otherOfferings) {
                isMatch = true;
            }
            else if (this.state.isClassesSelected && event.classes) {
                isMatch = true;
            }
        }

        return isMatch;
    }

    render() {
        return (
            <div className="cal-filters-category-container">
                <h2 className="cal-filters-category-title">Category</h2>
                <ul>
                    <li>
                        <label>
                            <input id="radio-shows"
                                type="radio"
                                onClick={this.radioButtonChangeBind}
                                checked={this.state.isShowsSelected} />
                            <label htmlFor="radio-shows">Shows</label>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input id="radio-other"
                                type="radio"
                                onClick={this.radioButtonChangeBind}
                                checked={this.state.isOtherOfferingsSelected} />
                            <label htmlFor="radio-other">Other Offerings</label>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input id="radio-classes"
                                type="radio"
                                onClick={this.radioButtonChangeBind}
                                checked={this.state.isClassesSelected} />
                            <label htmlFor="radio-classes">Education Programs</label>
                        </label>
                    </li>
                 </ul>
            </div>
        );
    }
}

export default (AccessibilitySelection);


// WEBPACK FOOTER //
// ./app/calendar/components/category-filter.tsx